module.exports = __webpack_public_path__ + "static/dance_768-d90cf2d011b4412e373e0578e99e2adb.jpg";